// extracted by mini-css-extract-plugin
export default {"toolbar":"Header_toolbar__S98bt","children":"Header_children__nLxNO","logo":"Header_logo__nBwfd","drawer":"Header_drawer__leNEX","footer":"Header_footer__+8jnG"};